<template lang="html">
  <div class="participant-form">
    <fieldset>

      <div class="row">
        <div class="form-group col-12 col-md-6" >
          <label for="inputAnrede" v-bind:class="{ 'label-error': validator.salutation.$error }">Anrede</label>
          <select class="form-control" id="inputAnrede" v-bind:class="{ 'is-invalid': validator.salutation.$error }" v-model="form.salutation" @change="onBlur">
            <option :value="undefined" disabled>-- Keine Anrede --</option>
            <option v-for="salutation in salutations" :value="salutation.Code">
              {{salutation.Description}}
            </option>
          </select>
        </div>
        <div class="form-group col-12 col-md-6">
          <label for="inputJob" v-bind:class="{ 'label-error': validator.job.$error }">Titel</label>
          <select class="form-control" id="inputJob" v-bind:class="{ 'is-invalid': validator.job.$error }" v-model="form.job" @change="onBlur">
            <option :value="undefined" disabled>-- Kein Titel --</option>
            <option v-for="job in jobs" :value="job.Code">
              {{job.Code}}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12 col-md-6">
                <label for="inputVorname" v-bind:class="{ 'label-error': validator.firstname.$error }">Vorname *</label>
                <input class="form-control" id="inputVorname" placeholder="Vorname" v-model="form.firstname" @blur="onBlur">
        </div>
        <div class="form-group col-12 col-md-6">
                <label for="inputNachname" v-bind:class="{ 'label-error': validator.lastname.$error }">Nachname *</label>
                <input class="form-control" id="inputNachname" placeholder="Nachname" v-model="form.lastname" @blur="onBlur">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12 col-md-12">
                <label for="inputVorname" v-bind:class="{ 'label-error': validator.street.$error }">Straße und Hausnummer *</label>
                <input class="form-control" id="inputVorname" placeholder="Straße und Hausnummer" v-model="form.street" @blur="onBlur">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12 col-md-4">
                <label for="inputPLZ" v-bind:class="{ 'label-error': validator.postalcode.$error }">Postleitzahl *</label>
                <input class="form-control" id="inputPLZ" placeholder="PLZ" v-model="form.postalcode" @blur="onBlur">
        </div>
        <div class="form-group col-12 col-md-8">
                <label for="inputOrt" v-bind:class="{ 'label-error': validator.city.$error }">Ort *</label>
                <input class="form-control" id="inputOrt" placeholder="Ort" v-model="form.city" @blur="onBlur">
        </div>
      </div>

      <div class="row">

        <div v-if="entrylocations.length >0" class="form-group col-12 col-md-4">
          <label for="inputZustiegsort"  v-bind:class="{ 'label-error': validator.entryLocation.$error }">Zustiegsort</label>
          <select class="form-control" id="inputZustiegsort" v-model="form.entryLocation" @change="onBlur">
            <option :value="undefined" disabled>Bitte Zustiegsort auswählen</option>
            <option v-for="loc in entrylocations" :value="loc">
              {{loc}}
            </option>
          </select>
        </div>

        <div class="form-group col-12 col-md-6">
          <label for="inputPrice" v-bind:class="{ 'label-error': validator.price.$error }">Preis *</label>
          <select class="form-control" id="inputPrice" v-bind:class="{ 'is-invalid': validator.price.$error }" v-model="form.price" @change="onBlur">
            <option v-for="pricerow in prices" :value="pricerow.price" @click="setPriceCode(pricerow.code)">
              {{pricerow.title}}, {{pricerow.price}} EUR
            </option>
          </select>
        </div>

      </div>

    </fieldset>
  </div>
</template>
<script>
export default {
  props: ['k', 'value', 'prices', 'entrylocations', 'jobs', 'salutations', 'validator', 'isOvernightSelectionRequired'],
  data () {
    return {
      form: {
        firstname: '',
        lastname: '',
        street: '',
        postalcode: '',
        city: '',
        overnight: true,
        discounts: [],
        price: null,
        pricecode: null
      }
    }
  },
  methods: {
    onBlur() {
      this.form.key = this.$props.k
      this.$emit('input', this.form)
    },
    setPriceCode(code) {
      this.form.pricecode = code
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Participant.vue